import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import MobileBottomNav from "./MobileBottomNav";
import CartDrawer from "./CartDrawer";
import WhatsAppButton from "./WhatsAppButton";
import { Outlet } from "react-router-dom";

export default function StoreLayout() {
  return (
    <div className="min-h-screen bg-[#FFF9FA] flex flex-col">
      <Header />
      <main className="flex-1 pb-20 md:pb-0"><Outlet /></main>
      <Footer />
      <MobileBottomNav />
      <CartDrawer />
      <WhatsAppButton />
    </div>
  );
}
